export const sort = (arr, key) => {
    if (arr?.length === 0) return arr;
    return arr?.sort((a, b) => {
        const nameA = isNaN(a[key]) ? a[key].toLowerCase() : Number(a[key]);
        const nameB = isNaN(b[key]) ? b[key].toLowerCase() : Number(b[key]);
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    });
};

export function remove(array, element, attr) {
    let index = -1;
    if (attr) {
        index = array.findIndex((item) => item[attr] === element);
    } else {
        index = array.indexOf(element);
    }
    if (index > -1) {
        array.splice(index, 1);
    }
}

export const arrayToObject = (array, key) => {
    const initialValue = {};
    return array.reduce((obj, item) => {
        return {
            ...obj,
            [item[key]]: item,
        };
    }, initialValue);
};

export function sortByProp(arr, prop, t) {
    if (!arr || !prop) return [];
    return arr.sort((a, b) => {
        const aProp = t ? t(a[prop]) : a[prop];
        const bProp = t ? t(b[prop]) : b[prop];
        if (aProp < bProp) {
            return -1;
        }
        if (aProp > bProp) {
            return 1;
        }
        return 0;
    });
}

export function getUniqueKeys(arr, key) {
    const uniqueKeys = arr
        .map((e) => e[key])
        .map((e, i, final) => final.indexOf(e) === i && i)
        .filter((e) => arr[e])
        .map((e) => arr[e]);

    return uniqueKeys;
}
